import React from 'react';
import { Send } from 'lucide-react';

// Notification Type card — summary vs direct + send-test button
export function NotificationTypeCard({ notificationType, setNotificationType, onSendTest }) {
    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
            <div className="p-6 border-b border-gray-100">
                <h2 className="text-lg font-bold text-gray-900 mb-1">
                    Notification Type
                </h2>
                <p className="text-gray-500 text-sm">Choose how detailed your notifications should be</p>
            </div>
            <div className="p-6 space-y-6">
                <div className="space-y-4">
                    <label className="flex items-start gap-3 cursor-pointer group">
                        <div className="mt-1">
                            <input
                                type="radio"
                                name="notificationType"
                                checked={notificationType === 'summary'}
                                onChange={() => setNotificationType('summary')}
                                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <span className="block text-sm font-bold text-gray-900 group-hover:text-blue-600 transition-colors">Summary notification</span>
                            <span className="block text-sm text-gray-500 mt-0.5">Get a count of new jobs (e.g. "Found 5 new freelance jobs") that links to your results page.</span>
                        </div>
                    </label>

                    <label className="flex items-start gap-3 cursor-pointer group">
                        <div className="mt-1">
                            <input
                                type="radio"
                                name="notificationType"
                                checked={notificationType === 'direct'}
                                onChange={() => setNotificationType('direct')}
                                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <span className="block text-sm font-bold text-gray-900 group-hover:text-blue-600 transition-colors">Direct job notification</span>
                            <span className="block text-sm text-gray-500 mt-0.5">Get the job title directly in the notification for instant access.</span>
                        </div>
                    </label>
                </div>

                <button
                    type="button"
                    onClick={onSendTest}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-50 hover:bg-blue-100 text-blue-600 font-medium rounded-lg transition-colors text-sm"
                >
                    <Send className="w-4 h-4" />
                    Send test notification
                </button>
            </div>
        </div>
    );
}
